export const SHIPPING_BEST = 'Domain\\Shippings\\Tariffs\\Best'
export const SHIPPING_EXPRESS = 'Domain\\Shippings\\Tariffs\\Express90'
export const SHIPPING_CZECHIA = 'Domain\\Shippings\\Tariffs\\Czechia'
export const SHIPPING_PICKUP = 'Domain\\Shippings\\Tariffs\\Pickup'
